export function filterDomainDescription(options) {
  return options?.map((option) =>
    option?.code === 'selfie-liveness'
      ? { ...option, description: "Selfie (SDK + Smartlive)" }
      : option
  );
}